import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCurrentUser, useSetWhenForItems } from "@sprout/client-graphql";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import { DeadlineDialog, SchedulerDialog } from "../Dialog_next";
import useMultiselectDialog from "./useMultiselectDialog";
export default function useWhenOrDeadlineGlobalHandler({ posts , onActionHandled  }) {
    const { dialog , selectedItemIds , openDialog , closeDialog  } = useMultiselectDialog();
    const currentUser = useCurrentUser();
    useActionRegistryGlobalHandler([
        "WHEN",
        "DEADLINE"
    ], useCallback((items, _event, command)=>{
        return openDialog({
            items: [
                ...items
            ],
            dialog: command === "WHEN" ? "schedule" : "deadline"
        });
    }, [
        openDialog
    ]), {
        skip: !currentUser
    });
    const selectedItems = useMemo(()=>{
        return posts.filter((item)=>selectedItemIds.includes(item.id));
    }, [
        posts,
        selectedItemIds
    ]);
    const setWhenForItems = useSetWhenForItems();
    const handleScheduled = useCallback(({ when , whenReminder  })=>{
        closeDialog();
        setWhenForItems({
            items: selectedItems,
            when,
            whenReminder
        });
        if (onActionHandled) onActionHandled({
            items: selectedItems,
            action: "schedule",
            when,
            deadline: undefined
        });
    }, [
        closeDialog,
        onActionHandled,
        selectedItems,
        setWhenForItems
    ]);
    const handleSetDeadline = useCallback(({ deadline  })=>{
        closeDialog();
        setWhenForItems({
            items: selectedItems,
            deadline
        });
        if (onActionHandled) onActionHandled({
            items: selectedItems,
            action: "deadline",
            when: undefined,
            deadline
        });
    }, [
        closeDialog,
        onActionHandled,
        selectedItems,
        setWhenForItems
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SchedulerDialog, {
                items: selectedItems,
                open: dialog === "schedule",
                onScheduled: handleScheduled,
                onRequestClose: closeDialog
            }),
            /*#__PURE__*/ _jsx(DeadlineDialog, {
                items: selectedItems,
                open: dialog === "deadline",
                onSetDeadline: handleSetDeadline,
                onRequestClose: closeDialog
            })
        ]
    });
};
